module.exports = __webpack_public_path__ + "img/audrey.7cd5bb8b.png";